export enum SortField {
  ALL = '',
  SEX = 'sex',
  NAME = 'name',
  BORN = 'born',
  DIED = 'died',
}
